export const films_1 = [{
	id: "69",
	titre: "GIMS au stade de France en 2019",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/1-3.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/3-B.jpg&w=900",
	desc: "DVD en version digitale - Après 43 zéniths à travers la France, le Luxembourg, La Belgique et la suisse, l'aventure du FUEGO TOUR initié en 2018 touchait à sa fin le 28 septembre 2019.",
	//bandeannonce: "https://player.vimeo.com/external/716703524.m3u8?s=6dc4040b4d182cacf19cfc52765c580c015e031b&oauth2_token_id=1608428293",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/716703524/rendition/1080p/gims_teaser_montage_final_hd%20%281080p%29.mp4?loc=external&signature=106e717d2df3f21e17e495b57aadff67adac9c9cd3169da3a0779ebbbbec6a7c",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "100",
	titre: "Les femmes des francos",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/1-5.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/5-B.png&w=900",
	desc: "Ce film, qui mélange interviews, extraits de concerts, séquences live, et archives musicales, retrace l'édition 2018 des Francofolies de La Rochelle",
	bandeannonce: "https://player.vimeo.com/external/718617716.m3u8?s=c809c7702e8be1d0599ccaab022292d83b454a28&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "101",
	titre: "Hellfest, le métal expliqué à ma mère",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/hellfest-1.png&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/hellfest-2.jpg&w=900",
	desc: "Chaque année, à Clisson, se déroule la référence des festivals de musique métal dans l'hexagone : le Hellfest. ",
	descLong: "Chaque année, à Clisson, se déroule la référence des festivals de musique métal dans l'hexagone : le Hellfest. Il réunit une affiche éclectique, des grands noms du hard rock des années 70-80, aux groupes actuels les plus pointus.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/718619919/rendition/1080p/file.mp4?loc=external&signature=4ac0f3b56cdca5ffee355fc210f4f2d0ecff8ab0acef6d35d285e35e6ad1a21c",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "102",
	titre: "Good Morning Bestival",
	img: "https://vcdn.inlive-stream.com/img/1-4.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/4-B.png&w=900",
	desc: "DVD Digital - Depuis quelques années, l'île de Wight s'embrase pendant trois jours de son des plus grands noms de la scène pop-rock",
	bandeannonce: "https://player.vimeo.com/external/718619845.m3u8?s=0c82a075adddd060cc09c4f1ea26e22b698f5e14&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
	/*
},{
	id: "61",
	titre: "Le Pyramide tour de M. Pokora 2020",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/mp_wtitle.png&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/pyramidtour-VISUEL.jpg&w=900",
	desc: "Revivez la tournée événement du Pyramide Tour 2019-2020 de M. Pokora",
	descLong: "A l'occasion de la sortie du DVD du Pyramide Tour en version digitale, visionnez le une première fois le 7 décembre 2021 à 21h00 en présence de Matt Pokora en visio live et tchattez en direct avec lui. Tout achat est définitif, vous pouvez le re-visionner en illimité depuis vos achats sur inlive-stream.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/699820925/rendition/1080p/teaser_dvd_digital_-_mat_-_pyramid_tour%20%281080p%29.mp4?loc=external&signature=ca3ea4a130ec655bae2ed1c0be4aea5841cd27941384da752d5ef25a2dc88db4",
	duree: "",
	achat:"14,99",
	loc:"",
	dureeLoc:"",
	type:"VIDEO",
	*/
}];
export const films_Mobile = [{
	id: "69",
	titre: "GIMS au stade de France en 2019",
	img: "1-3.jpg",
	imgB: "3-B.jpg",
	desc: "DVD en version digitale - Après 43 zéniths à travers la France, le Luxembourg, La Belgique et la suisse, l'aventure du FUEGO TOUR initié en 2018 touchait à sa fin le 28 septembre 2019.",
	//bandeannonce: "https://player.vimeo.com/external/716703524.m3u8?s=6dc4040b4d182cacf19cfc52765c580c015e031b&oauth2_token_id=1608428293",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/716703524/rendition/1080p/gims_teaser_montage_final_hd%20%281080p%29.mp4?loc=external&signature=106e717d2df3f21e17e495b57aadff67adac9c9cd3169da3a0779ebbbbec6a7c",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "100",
	titre: "Les femmes des francos",
	img: "1-5.jpg",
	imgB: "5-B.png",
	desc: "Ce film, qui mélange interviews, extraits de concerts, séquences live, et archives musicales, retrace l'édition 2018 des Francofolies de La Rochelle",
	bandeannonce: "https://player.vimeo.com/external/718617716.m3u8?s=c809c7702e8be1d0599ccaab022292d83b454a28&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "101",
	titre: "Hellfest, le métal expliqué à ma mère",
	img: "hellfest-1.png",
	imgB: "hellfest-2.jpg",
	desc: "Chaque année, à Clisson, se déroule la référence des festivals de musique métal dans l'hexagone : le Hellfest. ",
	descLong: "Chaque année, à Clisson, se déroule la référence des festivals de musique métal dans l'hexagone : le Hellfest. Il réunit une affiche éclectique, des grands noms du hard rock des années 70-80, aux groupes actuels les plus pointus.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/718619919/rendition/1080p/file.mp4?loc=external&signature=4ac0f3b56cdca5ffee355fc210f4f2d0ecff8ab0acef6d35d285e35e6ad1a21c",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "102",
	titre: "Good Morning Bestival",
	img: "1-4.jpg",
	imgB: "4-B.png",
	desc: "DVD Digital - Depuis quelques années, l'île de Wight s'embrase pendant trois jours de son des plus grands noms de la scène pop-rock",
	bandeannonce: "https://player.vimeo.com/external/718619845.m3u8?s=0c82a075adddd060cc09c4f1ea26e22b698f5e14&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "61",
	titre: "Le Pyramide tour de M. Pokora 2020",
	img: "mp_wtitle.png",
	imgB: "pyramidtour-VISUEL.jpg",
	desc: "Revivez la tournée événement du Pyramide Tour 2019-2020 de M. Pokora",
	descLong: "A l'occasion de la sortie du DVD du Pyramide Tour en version digitale, visionnez le une première fois le 7 décembre 2021 à 21h00 en présence de Matt Pokora en visio live et tchattez en direct avec lui. Tout achat est définitif, vous pouvez le re-visionner en illimité depuis vos achats sur inlive-stream.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/699820925/rendition/1080p/teaser_dvd_digital_-_mat_-_pyramid_tour%20%281080p%29.mp4?loc=external&signature=ca3ea4a130ec655bae2ed1c0be4aea5841cd27941384da752d5ef25a2dc88db4",
	duree: "",
	achat:"14,99",
	loc:"",
	dureeLoc:"",
	type:"VIDEO",
}];

export const dummy= [{
	titre: "",
	img: "",
	imgB: "",
	desc: "",
	descLong: "Y",
	bandeannonce: "",
	duree: "",
	achat:"",
	loc:"",
	dureeLoc:"",
	type:"",
}];

export const films_tv= [{
	id: "109",
	titre: "Star Academy Saison 1 - Prime 1",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "110",
	titre: "Star Academy Saison 1 - Prime 2",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "111",
	titre: "Star Academy Saison 1 - Prime 3",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "112",
	titre: "Star Academy Saison 1 - Prime 4",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "113",
	titre: "Star Academy Saison 1 - Prime 5",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "114",
	titre: "Star Academy Saison 1 - Prime 6",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "115",
	titre: "Star Academy Saison 1 - Prime 7",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "116",
	titre: "Star Academy Saison 1 - Prime 8",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "117",
	titre: "Star Academy Saison 1 - Prime 9",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "118",
	titre: "Star Academy Saison 1 - Prime 10",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "119",
	titre: "Star Academy Saison 1 - Prime 11",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "120",
	titre: "Star Academy Saison 1 - Prime 12",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{	
	id: "121",
	titre: "Star Academy Saison 1 - Prime 13",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
}];

export const films_docu = [{
	id: "135",
	titre: "Marc Lavoine - L'esprit de la transe (Maroc)",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/135.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/135-1.jpg&w=900",
	desc: "Notes de voyage - Marc Lavoine - L'esprit de la transe",
	descLong: "Le chanteur Marc Lavoine est un passionné du Maroc, où il se rend régulièrement. En sa compagnie, nous découvrons la musique et les danses traditionnelles de ce pays. Premier arrêt à Marrakech, au milieu de la palmeraie, pour une \"guedra\", une danse marocaine quasi hypnotique proche de celles de l'Asie du Sud-Est. Puis escale à Essaouira, avec les Gnaouas, des musiciens et thérapeutes qui s'inscrivent dans une tradition orale.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/755583614/rendition/1080p/bande_annonce_-_marc_lavoine_l%27esprit_de_la_transe%20%281080p%29.mp4?loc=external&signature=f8d4be9c4a43dc5fdb25474bc1994c292063eb73ad530a11c4fed42981fe9d10",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "134",
	titre: "Manu Chao, Giramundo Tour",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/134.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/134-1.jpg&w=900",
	desc: "Music Planet - Manu Chao, Giramundo Tour",
	descLong: "Manu Chao bouge avec pour seul équipement une petite caméra, sa guitare et un ordinateur. Manu compose, écrit et cherche son inspiration dans les nombreux voyages qu'il s'impose comme attitude. Les moments passés avec lui lors de sa tournée sud-américaine et chez lui à Barcelone dans son laboratoire d'alchimie sonore, sont très représentatifs de son choix de vie. Moments intimes d'un homme qui se livre rarement.",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "133",
	titre: "Jimmy Cliff, Moving on",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/133.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/133-1.jpg&w=900",
	desc: "Music Planet - Jimmy Cliff, Moving on",
	descLong: "Jimmy Cliff occupe une place à part dans l'histoire du reggae. Profondément jamaïcain, sa grande indépendance de pensée l'a pourtant conduit du christianisme aux rastas puis à l'islam, de la soul et du rock au reggae et au ska. Il a tiré de toutes ses expériences un enseignement original, et ce cheminement nourrit sa musique, l'une des plus vendues dans le monde. Chaloupant au travers des foules des ghettos, arpentant les collines de son enfance, méditant dans l'église de son village, Jimmy Cliff (né en 1948) nous raconte le destin d'un enfant de la campagne parti à l'assaut des feux de la rampe. En filigrane sont évoquées la naissance de la musique rasta, celle du ska et du reggae, l'amitié avec Bob Marley ; mais aussi les souffrances et l'extraordinaire créativité du peuple jamaïcain, qui donne au film ses moments les plus vrais. La musique - beaucoup de chansons a capella ou accompagnées à la guitare sèche - soulignent le rythme nonchalant du récit, et les images révèlent une Jamaïque pauvre, généreuse et inspirée, devant laquelle, souvent la superstar s'efface.",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "132",
	titre: "Jeff Buckley, Fall in light",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/132.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/132-1.jpg&w=900",
	desc: "Music Planet - Jeff Buckley, Fall in light",
	descLong: "Juin 1997 : l'annonce de la disparition de Jeff Buckley laisse la scène rock en état de choc. À l'instar de Jim Morrison, Kurt Cobain ou encore... Tim Buckley, son propre père, mort au même âge, vingt-deux ans plus tôt, l'artiste à la voix d'ange disparaît précocement alors qu'il n'a enregistré qu'un album, \"Grace\", en 1994. Quatre titres capturés live cette même année (\"Live at Sin-é\") et un album posthume (\"Sketches for my Sweatheart\", \"The Drunk\") viennent compléter la maigre discographie de Buckley Jr. Installé à New York, il met d'abord sa musique à l'épreuve du public dans les petits cafés autour de St Mark's Place. Côté influences, sa filiation avec Robert Plant (Led Zeppelin) est évidente : une voix qui oscille entre les tonalités orientales, une sensibilité afro-américaine et l'énergie abrasive du rock.",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "131",
	titre: "Jean-Louis Aubert - Jah magic (Kingston / Jamaïque)",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/131.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/131-1.jpg&w=900",
	desc: "Notes de voyage - Jean-Louis Aubert - Jah magic",
	descLong: "Avec sa guitare qui fait office de baluchon, Jean-Louis Aubert se balade de ville en ville à la recherche des racines du Reggae. Pendant les moments de répit, il improvise des duos de guitares, notamment avec Chaka Demus ou alors avec de simples anonymes.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/755583380/rendition/1080p/jean-louis_aubert_jah_magic%20%281080p%29.mp4?loc=external&signature=cdbd6bfde1d2c602b504af1ab38f368ad1bce4892c60ec15af7a8895df6aa4be",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "130",
	titre: "Iggy Pop, La rage de vivre",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/130.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/130-1.jpg&w=900",
	desc: "Music Planet - Iggy Pop, La rage de vivre",
	descLong: "Inventeur du punk à la fin des années 60 avec ses mythiques \"Stooges\", Iggy Pop a survécu à tous les excès chimiques et sonores. À plus de cinquante ans, ce rocker emblématique a gardé la ligne, la classe et la rage. De somptueuses archives montrent les \"Stooges\" semant le chaos en 1970. Aujourd'hui, Iggy Pop est remarquablement disert, cultivé et courtois. Sauf sur scène...",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "129",
	titre: "Les Gipsy Kings vus d'Amérique - Tierra Gitana",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/129.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/129-1.jpg&w=900",
	desc: "Music Planet - Les Gipsy Kings vus d'Amérique - Tierra Gitana",
	descLong: "Présentation d'archives d'une famille exceptionnelle, d'interviews et d'extraits de concerts pour comprendre le succès des Gipsy Kings, consacrés meilleur groupe de \"latin pop music\".",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "128",
	titre: "Docteur Bowie & Mister Jones",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/128.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/128-1.jpg&w=900",
	desc: "Music Planet - Docteur Bowie & Mister Jones",
	descLong: "Depuis plus de quatre décennies, David Robert Jones, alias Bowie, s'impose en monstre protéiforme du rock : créature incertaine, androgyne, prétentieuse, surhumaine, magnifique. Christian Fevret, fondateur et ex-directeur de la rédaction des Inrockuptibles, a réalisé cet entretien rare, nourri d'archives souvent inédites, avec l'icône glam à l'aube du millénaire. Un portrait qui s'attarde sur les années 1970 quand l'homme au regard vairon flirtait plus avec la marge et l'avant-garde qu'avec les tubes planétaires des eighties comme Let's dance. (...) À propos de son avatar outré et outrageant Ziggy Stardust, l'ex-timide rappelle simplement : \"Je pouvais disparaître derrière lui et affronter le public.\" L'occasion aussi d'un passage en revue de ses fructueuses collaborations avec Lou Reed ou Iggy Pop - qu'il sauve du déclin -, de ses mémorables apparitions au cinéma (Furyo ou Absolute beginners), de sa performance dans Elephant man à Broadway, ou encore de sa passion pour la peinture, perceptible sur ses très soignées pochettes de disque. Revoir un Bowie transformiste assiégé par ses fans en délire réjouit franchement, tout comme entendre ce génie de l'anticipation, du rebond et du business évoquer le destin de fils de prolo de Brixton auquel il a échappé.",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "127",
	titre: "Charlélie Couture - Impressions vietnamiennes (Vietnam)",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/127.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/127-1.jpg&w=900",
	desc: "Notes de voyage - Charlélie Couture - Impressions vietnamiennes",
	descLong: "Charlélie Couture, Enzo Enzo et Ismaël Lô partent au Vietnam pour y découvrir la culture et les chants traditionnels. C'est tout un folklore que les artistes rencontrent tout au long de ce voyage.",
	bandeannonce: "https://player.vimeo.com/external/734618153.m3u8?s=6a17980a53a3f0194fd9fd8efeb8ffdc2d88d85c&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "126",
	titre: "Patricia Kaas - Une histoire simple, Saint-Pétersbourg (Russie)",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/126-1.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/126.jpg&w=900",
	desc: "Notes de voyage - Patricia Kaas - Une histoire simple, Saint-Pétersbourg",
	descLong: "Depuis ses premiers radio-crochets en Lorraine, remportés à l'âge de huit ans, on peut considérer le parcours de Patricia Kaas comme exceptionnel. Elle est sans nul doute devenue une ambassadrice de choix de la langue et de la chanson française, pour le plus grand plaisir de ses fans, francophones ou non. Au printemps 1998, elle s'est rendue dans les pays de l'Est, notamment en Russie, pour y donner une série de concerts. Caméra au poing, une équipe de tournage l'a suivie tout au long de son périple, permettant ainsi de connaître cette artiste, une femme simple, sensible et touchée par la chaleur de ses fans.",
	bandeannonce: "https://player.vimeo.com/external/734636956.m3u8?s=6ab7ea2e1e6991dbc585e7c21e4e6eb41e62c96b&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "125",
	titre: "Rennes en trans",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/125.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/125-1.jpg&w=900",
	desc: "Rennes en trans",
	descLong: "« Un portrait du festival des Transmusicales au travers de son édition de 1998. Avec P18, Baaba Maal, Tryo... »",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "124",
	titre: "Toto la Momposina, Une voix pour la Colombie",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/124.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/124-1.jpg&w=900",
	desc: "Music Planet - Toto la Momposina, Une voix pour la Colombie",
	descLong: "En Colombie, les traditions indiennes et africaines, considérées comme \"de bas étage\", ont été occultées pendant des siècles et seraient peut-être tombées dans l'oubli sans Toto La Momposina. Cette chanteuse charismatique, issue des deux communautés, a entrepris une tâche gigantesque de recherche et de réhabilitation des styles anciens, et ses spectacles ont conquis la scène des musiques du monde. Catalina Villar nous emmène à la rencontre de la \"tribu\" de Toto et, plus largement, de son peuple. Fêtes religieuses, travail aux champs, retour des troupeaux, pilage du maïs, tout est prétexte à chansons que Toto recueille précieusement et s'efforce d'inculquer à la jeune génération. Si elle convainc grâce à sa voix intacte, son maintien royal et le coeur qu'elle met à tout ce qu'elle entreprend, il est parfois difficile pour elle de forcer ses congénères à remonter le temps. Dans une scène poignante, elle demande à la population d'un village de se joindre à elle en dansant, mais lorsqu'elle découvre qu'aucun d'entre eux ne se souvient du rythme en question, elle laisse exploser ses larmes et sa colère... Le portrait d'une grande dame, tout en couleurs et en émotions.",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "123",
	titre: "Ben Harper and the Innocent Criminals",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/123.png&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/123-1.jpg&w=900",
	desc: "Music Planet - Ben Harper and the Innocent Criminals",
	descLong: "Ben Harper, musicien surdoué, fils spirituel de Jimmy Hendrix et de Bob Marley, ne colle à aucun mouvement et ne tolère aucune étiquette. Il ne dérive d'aucune filiation branchée et son succès n'est pas du à un gigantesque effort de promotion. Portrait d'une étoile montante, le plus jeune des vieux sages qui nous invite à découvrir sa musique métissée, faite de folk, blues, reggae, grunge et gospel. Le film propose de suivre l'artiste au cours de sa tournée européenne, à Marseille, Lyon, Rome, Madrid, Barcelone ou Lisbonne. Entretiens, extraits de concerts, mais aussi morceaux interprétés en acoustique dans les décors traversés (petite place à Rome, docks du port de Lisbonne).",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/731359978/rendition/1080p/file.mp4?loc=external&signature=c09f4043165ac1ff5512e11a1d61fa19f9a382ef133f63bd62540cc937ebea9b",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "122",
	titre: "Dan ar braz à Dublin - Vers les îles (Irlande)",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/102-2.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/102-1.jpg&w=900",
	desc: "Notes de voyage - Dan ar braz à Dublin - Vers les îles",
	descLong: "Figure de la musique celtique, Dan Ar Braz nous emmène dans ses pérégrinations en Irlande, en Ecosse et en Bretagne. Au travers de concerts et de rencontres, l'artiste se confie pudiquement sur son travail et sa carrière.",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "100",
	titre: "Les femmes des francos",
	img: "https://vcdn.inlive-stream.com/img/1-5.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/5-B.png&w=900",
	desc: "Ce film, qui mélange interviews, extraits de concerts, séquences live, et archives musicales, retrace l'édition 2018 des Francofolies de La Rochelle",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/718617716/rendition/1080p/bande_annonce_les_femmes_des_francos%20%281080p%29.mp4?loc=external&signature=9609ba0222b4cba37d1c8403ef65367d9fa694cb0908059fba66963a991a650c",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "101",
	titre: "Hellfest, le métal expliqué à ma mère",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/hellfest-1.png&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/hellfest-2.jpg&w=900",
	desc: "Chaque année, à Clisson, se déroule la référence des festivals de musique métal dans l'hexagone : le Hellfest. ",
	descLong: "Chaque année, à Clisson, se déroule la référence des festivals de musique métal dans l'hexagone : le Hellfest. Il réunit une affiche éclectique, des grands noms du hard rock des années 70-80, aux groupes actuels les plus pointus.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/718619919/rendition/1080p/file.mp4?loc=external&signature=4ac0f3b56cdca5ffee355fc210f4f2d0ecff8ab0acef6d35d285e35e6ad1a21c",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "102",
	titre: "Good Morning Bestival",
	img: "https://vcdn.inlive-stream.com/img/1-4.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/4-B.png&w=900",
	desc: "Depuis quelques années, l'île de Wight s'embrase pendant trois jours de son des plus grands noms de la scène pop-rock",
	bandeannonce: "https://player.vimeo.com/external/718619845.m3u8?s=0c82a075adddd060cc09c4f1ea26e22b698f5e14&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "103",
	titre: "Rock & the city Paris",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/V_RC_Paris.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/RC_Paris.png&w=900",
	desc: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes...",
	descLong: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes qui nous entraînent dans leur environnement quotidien. Entre images d'archives et anecdotes, endroits célèbres ou insolites, ces documentaires explorent l'histoire passée, présente et future de la musique en faisant découvrir le coeur de chaque ville. Paris : un voyage musical raconté par la voix chaleureuse et passionnée de Philippe Manoeuvre.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/731405493/rendition/1080p/file.mp4?loc=external&signature=636af5320e76992cc200298410c557bae69beb7ae3b7f94b7d2d6c8dd7b5a1ac",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "104",
	titre: "Rock & the city Berlin",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/V_RC_Berlin.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/RC_Berlin.png&w=900",
	desc: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes...",
	descLong: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes qui nous entraînent dans leur environnement quotidien. Entre images d'archives et anecdotes, endroits célèbres ou insolites, ces documentaires explorent l'histoire passée, présente et future de la musique en faisant découvrir le coeur de chaque ville. Berlin : un voyage musical raconté par la voix chaleureuse et passionnée de Philippe Manoeuvre.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/755583557/rendition/1080p/bande_annonce_-_rock_&_the_city_-_berlin%20%281080p%29.mp4?loc=external&signature=479e5fffc0d82d197c408cc526646465b7658e79d327185377746c60e24116a9",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id:"105",
	titre: "Rock & the city Kingston",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/V_RC_Kingston.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/RC_Kingston.png&w=900",
	desc: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes...",
	descLong: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes qui nous entraînent dans leur environnement quotidien. Entre images d'archives et anecdotes, endroits célèbres ou insolites, ces documentaires explorent l'histoire passée, présente et future de la musique en faisant découvrir le coeur de chaque ville. Kingston : un voyage musical raconté par la voix chaleureuse et passionnée de Philippe Manoeuvre.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/731375732/rendition/1080p/file.mp4?loc=external&signature=5e5e4a47cf8144ce01176b7ab440eff09186f73c9991b5b29aca2c1a29d819e7",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "106",
	titre: "Rock & the city Liverpool",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/V_RC_Liverpool.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/RC_Liverpool.png&w=900",
	desc: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes...",
	descLong: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes qui nous entraînent dans leur environnement quotidien. Entre images d'archives et anecdotes, endroits célèbres ou insolites, ces documentaires explorent l'histoire passée, présente et future de la musique en faisant découvrir le coeur de chaque ville. Liverpool : un voyage musical raconté par la voix chaleureuse et passionnée de Philippe Manoeuvre.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/731385773/rendition/1080p/file.mp4?loc=external&signature=d5932bfc6fe412357663481e657acba0e660cd1a0e71d3601ef6a8dbfedae7b2",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "107",
	titre: "Rock & the city New York",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/V_RC_NewYork.jpg&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/RC_NewYork.png&w=900",
	desc: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes...",
	descLong: "Rock And The City propose un portrait inédit de villes mythiques qui ont marqué l'histoire de la musique. Chaque film est conçu comme un voyage initiatique, à travers des rencontres d'artistes qui nous entraînent dans leur environnement quotidien. Entre images d'archives et anecdotes, endroits célèbres ou insolites, ces documentaires explorent l'histoire passée, présente et future de la musique en faisant découvrir le coeur de chaque ville. New York : un voyage musical raconté par la voix chaleureuse et passionnée de Philippe Manoeuvre.",
	bandeannonce: "",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "108",
	titre: "From Wight to wight",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/FW2W_N.png&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/FW2W_H.png&w=900",
	desc: "En août 70, le festival de l'ile de Wight réuni 600 000 spectateurs pour ce qui sera, sans le savoir, la dernière édition de l'époque.",
	descLong: "En août 70, le festival de l'ile de Wight réuni 600 000 spectateurs pour ce qui sera, sans le savoir, la dernière édition de l'époque. Joan Baez, Léonard Cohen, Hendricks, les Who, les Doors font parti des têtes d'affiches légendaires... Philippe Manoeuvre nous emmène sur place lors de l'édition 2010, et nous fait revivre l'histoire de ce festival mythique.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/playback/731365453/rendition/1080p/file.mp4?loc=external&signature=d0b74eb033fe8716cf91f9e5642a7cd59e7020765e0817e37e4bbe5bfa946f59",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
}];

export const films_concert = [{
	id: "61",
	titre: "Le Pyramide tour de M. Pokora 2020",
	img: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/mp_wtitle.png&w=421",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/pyramidtour-VISUEL.jpg&w=900",
	desc: "Revivez la tournée événement du Pyramide Tour 2019-2020 de M. Pokora",
	descLong: "A l'occasion de la sortie du DVD du Pyramide Tour en version digitale, visionnez le une première fois le 7 décembre 2021 à 21h00 en présence de Matt Pokora en visio live et tchattez en direct avec lui. Tout achat est définitif, vous pouvez le re-visionner en illimité depuis vos achats sur inlive-stream.",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/699820925/rendition/1080p/teaser_dvd_digital_-_mat_-_pyramid_tour%20%281080p%29.mp4?loc=external&signature=ca3ea4a130ec655bae2ed1c0be4aea5841cd27941384da752d5ef25a2dc88db4",
	duree: "",
	achat:"14,99",
	loc:"",
	dureeLoc:"",
	type:"VIDEO",
},{	
	id: "67",
	titre: "Jenifer à l'Olympia 2020",
	img: "https://vcdn.inlive-stream.com/img/1-1.png",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/1-B.jpg&w=900",
	desc: "Revivez le concert événement de Jenifer à l'Olympia",
	//bandeannonce: "https://player.vimeo.com/external/716696104.m3u8?s=6d9149b09c70ac2ca4e76ca89230bc385d64a0c7&oauth2_token_id=1608428293",
	bandeannonce:"https://player.vimeo.com/progressive_redirect/download/716696104/rendition/1080p/teaser_dvd_digital-jenifer_fc%20%281080p%29.mp4?loc=external&signature=b33b3f50056b3897c0c3de99add77c7b6333e6dc525634293437c55c914921be",
	achat:"14,99",
	loc:"",
	dureeLoc:"24h",
	type:"VIDEO",
},{
	id:"68",
	titre: "TROIS CAFES GOURMANDS",
	img: "https://vcdn.inlive-stream.com/img/1-2.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/2-B.jpg&w=900",
	desc: "Le groupe nous présente le live de leur concert enregistré au zénith de Saint Etienne en 2019 !",
	bandeannonce:"https://player.vimeo.com/progressive_redirect/download/751629974/rendition/1080p/trois_caf%C3%A9s_gourmands%20%281080p%29.mp4?loc=external&signature=dd4c1315070867d87b16fbc46dc08353f27ac852caad44ed3b6c91711c1be5a7",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "69",
	titre: "GIMS au stade de France en 2019",
	img: "https://vcdn.inlive-stream.com/img/1-3.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/3-B.jpg&w=900",
	desc: "DVD en version digitale - Après 43 zéniths à travers la France, le Luxembourg, La Belgique et la suisse, l'aventure du FUEGO TOUR initié en 2018 touchait à sa fin le 28 septembre 2019.",
	//bandeannonce: "https://player.vimeo.com/external/716703524.m3u8?s=6dc4040b4d182cacf19cfc52765c580c015e031b&oauth2_token_id=1608428293",
	bandeannonce: "https://player.vimeo.com/progressive_redirect/download/716703524/rendition/1080p/gims_teaser_montage_final_hd%20%281080p%29.mp4?loc=external&signature=106e717d2df3f21e17e495b57aadff67adac9c9cd3169da3a0779ebbbbec6a7c",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
}];


export const films_2 = [{
	id: "102",
	titre: "Good Morning Bestival",
	img: "https://vcdn.inlive-stream.com/img/1-4.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/4-B.png&w=900",
	desc: "DVD Digital - Depuis quelques années, l'île de Wight s'embrase pendant trois jours de son des plus grands noms de la scène pop-rock",
	bandeannonce: "https://player.vimeo.com/external/718619845.m3u8?s=0c82a075adddd060cc09c4f1ea26e22b698f5e14&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	id: "100",
	titre: "Les femmes des francos",
	img: "https://vcdn.inlive-stream.com/img/1-5.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/5-B.png&w=900",
	desc: "Ce film, qui mélange interviews, extraits de concerts, séquences live, et archives musicales, retrace l'édition 2018 des Francofolies de La Rochelle",
	bandeannonce: "https://player.vimeo.com/external/718617716.m3u8?s=c809c7702e8be1d0599ccaab022292d83b454a28&oauth2_token_id=1608428293",
	isHD: "0",
	achat:"",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre:"L'in extremis Tour",
	img:"https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/cabrel-1.jpg&w=421",
	imgB:"https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/cabrel-1.jpg&w=900",
	desc:"Après le succès de l'album IN EXTREMIS, découvrez le live de la tournée IN EXTREMIS TOUR.",
	descLong: "Après le succès de l'album IN EXTREMIS, découvrez le live de la tournée IN EXTREMIS TOUR. Inclus : l'intégralité du concert, filmé et enregistré au Forest National à Bruxelles les 4 &amp; 5 mars 2016, ainsi que le making of de la tournée.",
	bandeannonce: "https://player.vimeo.com/external/720664350.m3u8?s=609d35ca5576f55f60e70e721017da40f21e762a&oauth2_token_id=1608428293",
	production: "Come On Productions",
	annee: "2016",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"24h",
	type:"VIDEO",
},{
	titre: "Star Academy Saison 1",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre: "Jenifer à l'Olympia 2020",
	img: "https://vcdn.inlive-stream.com/img/1-1.png",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/1-B.jpg&w=900",
	desc: "Revivez le concert événement de Jenifer à l'Olympia",
	bandeannonce: "https://player.vimeo.com/external/716696104.m3u8?s=6d9149b09c70ac2ca4e76ca89230bc385d64a0c7&oauth2_token_id=1608428293",
	//bandeannonce:"https://player.vimeo.com/progressive_redirect/download/716696104/rendition/1080p/teaser_dvd_digital-jenifer_fc%20%281080p%29.mp4?loc=external&signature=b33b3f50056b3897c0c3de99add77c7b6333e6dc525634293437c55c914921be",
	achat:"14,99",
	loc:"",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre: "TROIS CAFES GOURMANDS",
	img: "https://vcdn.inlive-stream.com/img/1-2.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/2-B.jpg&w=900",
	desc: "DVD en version digitale au zénith de Saint Etienne en 2019",
	bandeannonce:"https://player.vimeo.com/progressive_redirect/download/751629974/rendition/1080p/trois_caf%C3%A9s_gourmands%20%281080p%29.mp4?loc=external&signature=dd4c1315070867d87b16fbc46dc08353f27ac852caad44ed3b6c91711c1be5a7",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre: "GIMS au stade de France en 2019",
	img: "https://vcdn.inlive-stream.com/img/1-3.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/3-B.jpg&w=900",
	desc: "DVD en version digitale - Après 43 zéniths à travers la France, le Luxembourg, La Belgique et la suisse, l'aventure du FUEGO TOUR initié en 2018 touchait à sa fin le 28 septembre 2019.",
	bandeannonce: "https://player.vimeo.com/external/716703524.m3u8?s=6dc4040b4d182cacf19cfc52765c580c015e031b&oauth2_token_id=1608428293",
	//bandeannonce: "https://player.vimeo.com/progressive_redirect/download/716703524/rendition/1080p/gims_teaser_montage_final_hd%20%281080p%29.mp4?loc=external&signature=106e717d2df3f21e17e495b57aadff67adac9c9cd3169da3a0779ebbbbec6a7c",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"24h",
	type:"VIDEO",
}];

export const films_3 = [{
	titre: "Star Academy Saison 1",
	img: "https://vcdn.inlive-stream.com/img/1-6.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/6-B.jpg&w=900",
	desc: "Revivez tous les primes de l'émission culte la Star Academy saison 1",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"24h",
	type:"VIDEO",
},{
	titre: "Jenifer à l'Olympia 2020",
	img: "https://vcdn.inlive-stream.com/img/1-1.png",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/1-B.jpg&w=900",
	desc: "Revivez le concert événement de Jenifer à l'Olympia",
	bandeannonce: "https://player.vimeo.com/external/716696104.m3u8?s=6d9149b09c70ac2ca4e76ca89230bc385d64a0c7&oauth2_token_id=1608428293",
	//bandeannonce:"https://player.vimeo.com/progressive_redirect/download/716696104/rendition/1080p/teaser_dvd_digital-jenifer_fc%20%281080p%29.mp4?loc=external&signature=b33b3f50056b3897c0c3de99add77c7b6333e6dc525634293437c55c914921be",
	achat:"14,99",
	loc:"",
	dureeLoc:"24h",
	type:"VIDEO",
},{
	titre: "TROIS CAFES GOURMANDS",
	img: "https://vcdn.inlive-stream.com/img/1-2.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/2-B.jpg&w=900",
	desc: "DVD en version digitale au zénith de Saint Etienne en 2019",	
	bandeannonce:"https://player.vimeo.com/progressive_redirect/download/751629974/rendition/1080p/trois_caf%C3%A9s_gourmands%20%281080p%29.mp4?loc=external&signature=dd4c1315070867d87b16fbc46dc08353f27ac852caad44ed3b6c91711c1be5a7",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre: "GIMS au stade de France en 2019",
	img: "https://vcdn.inlive-stream.com/img/1-3.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/3-B.jpg&w=900",
	desc: "DVD en version digitale - Après 43 zéniths à travers la France, le Luxembourg, La Belgique et la suisse, l'aventure du FUEGO TOUR initié en 2018 touchait à sa fin le 28 septembre 2019.",
	bandeannonce: "https://player.vimeo.com/external/716703524.m3u8?s=6dc4040b4d182cacf19cfc52765c580c015e031b&oauth2_token_id=1608428293",
	//bandeannonce: "https://player.vimeo.com/progressive_redirect/download/716703524/rendition/1080p/gims_teaser_montage_final_hd%20%281080p%29.mp4?loc=external&signature=106e717d2df3f21e17e495b57aadff67adac9c9cd3169da3a0779ebbbbec6a7c",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre: "Good Morning Bestival",
	img: "https://vcdn.inlive-stream.com/img/1-4.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/4-B.png&w=900",
	desc: "DVD Digital - Depuis quelques années, l'île de Wight s'embrase pendant trois jours de son des plus grands noms de la scène pop-rock",
	bandeannonce: "https://player.vimeo.com/external/718619845.m3u8?s=0c82a075adddd060cc09c4f1ea26e22b698f5e14&oauth2_token_id=1608428293",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
},{
	titre: "Les femmes des francos",
	img: "https://vcdn.inlive-stream.com/img/1-5.jpg",
	imgB: "https://cimage.inlive-stream.com/img.php?src=https://vcdn.inlive-stream.com/img/5-B.png&w=900",
	desc: "Ce film, qui mélange interviews, extraits de concerts, séquences live, et archives musicales, retrace l'édition 2018 des Francofolies de La Rochelle",
	bandeannonce: "https://player.vimeo.com/external/718617716.m3u8?s=c809c7702e8be1d0599ccaab022292d83b454a28&oauth2_token_id=1608428293",
	achat:"9,99",
	loc:"2,99",
	dureeLoc:"48h",
	type:"VIDEO",
}];